import {
  makeStyles, shorthands, tokens,
} from '@fluentui/react-components';

export const useFormCardHeaderStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    ...shorthands.padding(tokens.spacingVerticalMNudge, tokens.spacingHorizontalL),
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  divider: {
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
  },
});
